import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import dayjs from "dayjs";
import HistorySpinner from "../components/historySpinner";

const LogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log("Current user:", auth.currentUser);
  console.log(auth.currentUser?.email);

  useEffect(() => {
    const fetchLogs = async () => {
      const start = Date.now();

      const q = query(collection(db, "logs"), orderBy("timestamp", "desc"));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setLogs(data);

      const elapsed = Date.now() - start;
      setTimeout(() => setLoading(false), Math.max(0, 1000 - elapsed));
    };

    fetchLogs();
  }, []);

  if (loading) return <HistorySpinner />;

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Inventory History</h1>
      <table className="w-full border text-sm">
        <thead className="bg-gray-200">
          <tr>
            <th className="p-2 text-left">User</th>
            <th className="p-2">Brand</th>
            <th className="p-2">Section</th>
            <th className="p-2">Action</th>
            <th className="p-2">Change</th>
            <th className="p-2">Date</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id} className="border-t">
              <td className="p-2">{log.user || "Unknown"}</td>
              <td className="p-2">{log.brand || "Unknown"}</td>
              <td className="p-2">{log.section || "Unknown"}</td>
              <td className="p-2">{log.action || "Unknown"}</td>
              <td className="p-2 text-center">
                {typeof log.change === "number" ? (log.change > 0 ? `+${log.change}` : log.change) : "N/A"}
              </td>
              <td className="p-2 text-right">
                {log.timestamp
                  ? dayjs(log.timestamp.toDate()).format("YYYY-MM-DD HH:mm")
                  : "No Date"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LogsPage;
